export default __webpack_public_path__ + "static/media/create_a_coalition.cd6b1fcf.svg";